// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2026 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

import { IJSONSchema } from '@glittr/frontend-core/src/plugins/validation/IJSONSchema';
import ResourceLinkSchema from './resource-link-schema';

const schema = {
  $id: '/tdg-organisation-list-schema',
  type: 'object',
  required: ['id', 'creatorId', 'membersCount', 'eventId'],
  nullable: true,
  properties: {
    id: {
      type: 'integer',
    },
    links: {
      type: 'array',
      nullable: true,
      items: { ...ResourceLinkSchema },
    },
    creatorId: {
      type: 'integer',
    },
    creatorName: {
      type: 'string',
      nullable: true,
    },
    created: {
      type: 'string',
      format: 'date-time',
    },
    modifierId: {
      type: 'integer',
      nullable: true,
    },
    modifierName: {
      type: 'string',
      nullable: true,
    },
    modified: {
      type: 'string',
      format: 'date-time',
      nullable: true,
    },
    externalId: {
      type: 'string',
      format: 'uuid',
    },
    organisationName: {
      type: 'string',
      nullable: true,
    },
    logoDocumentId: {
      type: 'integer',
      nullable: true,
    },
    membersCount: {
      type: 'integer',
    },
    organisationContactSalutation: {
      type: 'integer',
      nullable: true,
    },
    organisationContactFirstName: {
      type: 'string',
      nullable: true,
    },
    organisationContactLastName: {
      type: 'string',
      nullable: true,
    },
    organisationContactPhoneNumber: {
      type: 'string',
      nullable: true,
    },
    organisationContactEmail: {
      type: 'string',
      nullable: true,
    },
    organisationStreet: {
      type: 'string',
      nullable: true,
    },
    organisationHouseNumber: {
      type: 'string',
      nullable: true,
    },
    organisationZIP: {
      type: 'string',
      nullable: true,
    },
    organisationCity: {
      type: 'string',
      nullable: true,
    },
    isActive: {
      type: 'boolean',
      nullable: true,
    },
    acceptConditions: {
      type: 'boolean',
    },
    isSupporter: {
      type: 'boolean',
      nullable: true,
    },
    eventId: {
      type: 'integer',
    },
    eventName: {
      type: 'string',
      nullable: true,
    },
    eventIdentifier: {
      type: 'string',
      format: 'uuid',
    },
  },
} as IJSONSchema;

export default schema;
